/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.forms.routing.rpc.LegacyFormsRoutingService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './LegacyFormsRoutingService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.forms.routing.rpc.LegacyFormsRoutingService#getDraftRouting
 */
export const GET_DRAFT_ROUTING_QUERY_FIELD_NAME = 'com_hubspot_forms_routing_rpc_LegacyFormsRoutingService_getDraftRouting';
export const GET_DRAFT_ROUTING_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_DRAFT_ROUTING_QUERY_FIELD_NAME,
  args: ['formId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getDraftRoutingRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.forms.routing.rpc.LegacyFormsRoutingService#updateDraftRouting
 */
export const UPDATE_DRAFT_ROUTING_MUTATION_FIELD_NAME = 'com_hubspot_forms_routing_rpc_LegacyFormsRoutingService_updateDraftRouting';
export const UPDATE_DRAFT_ROUTING_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_DRAFT_ROUTING_MUTATION_FIELD_NAME,
  args: ['formRouting'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.updateDraftRoutingRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.forms.routing.rpc.LegacyFormsRoutingService#getRoutingEvaluation
 */
export const GET_ROUTING_EVALUATION_QUERY_FIELD_NAME = 'com_hubspot_forms_routing_rpc_LegacyFormsRoutingService_getRoutingEvaluation';
export const GET_ROUTING_EVALUATION_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ROUTING_EVALUATION_QUERY_FIELD_NAME,
  args: ['formId', 'submissionValues'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getRoutingEvaluationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});